"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfProductPromotionsEditViewModel = instanceOfProductPromotionsEditViewModel;
exports.ProductPromotionsEditViewModelFromJSON = ProductPromotionsEditViewModelFromJSON;
exports.ProductPromotionsEditViewModelFromJSONTyped = ProductPromotionsEditViewModelFromJSONTyped;
exports.ProductPromotionsEditViewModelToJSON = ProductPromotionsEditViewModelToJSON;
exports.ProductPromotionsEditViewModelToJSONTyped = ProductPromotionsEditViewModelToJSONTyped;
/**
 * Check if a given object implements the ProductPromotionsEditViewModel interface.
 */
function instanceOfProductPromotionsEditViewModel(value) {
    if (!('wsppPromotionsName' in value) || value['wsppPromotionsName'] === undefined)
        return false;
    if (!('wsppUseStatus' in value) || value['wsppUseStatus'] === undefined)
        return false;
    return true;
}
function ProductPromotionsEditViewModelFromJSON(json) {
    return ProductPromotionsEditViewModelFromJSONTyped(json, false);
}
function ProductPromotionsEditViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'wsppPromotionsNo': json['wsppPromotionsNo'] == null ? undefined : json['wsppPromotionsNo'],
        'wsppOrgId': json['wsppOrgId'] == null ? undefined : json['wsppOrgId'],
        'wsppWebSiteNo': json['wsppWebSiteNo'] == null ? undefined : json['wsppWebSiteNo'],
        'wsppPromotionsName': json['wsppPromotionsName'],
        'wsppPromotionsCode': json['wsppPromotionsCode'] == null ? undefined : json['wsppPromotionsCode'],
        'wsppPromotionsDateS': json['wsppPromotionsDateS'] == null ? undefined : json['wsppPromotionsDateS'],
        'wsppPromotionsDateE': json['wsppPromotionsDateE'] == null ? undefined : json['wsppPromotionsDateE'],
        'wsppApplicableType': json['wsppApplicableType'] == null ? undefined : json['wsppApplicableType'],
        'wsppPromotionsType': json['wsppPromotionsType'] == null ? undefined : json['wsppPromotionsType'],
        'wsppProductMenuNo': json['wsppProductMenuNo'] == null ? undefined : json['wsppProductMenuNo'],
        'wsppDiscountType': json['wsppDiscountType'] == null ? undefined : json['wsppDiscountType'],
        'wsppDiscountValue': json['wsppDiscountValue'] == null ? undefined : json['wsppDiscountValue'],
        'wsppUseStatus': json['wsppUseStatus'],
        'wsppDisabledDate': json['wsppDisabledDate'] == null ? undefined : (new Date(json['wsppDisabledDate'])),
    };
}
function ProductPromotionsEditViewModelToJSON(json) {
    return ProductPromotionsEditViewModelToJSONTyped(json, false);
}
function ProductPromotionsEditViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'wsppPromotionsNo': value['wsppPromotionsNo'],
        'wsppOrgId': value['wsppOrgId'],
        'wsppWebSiteNo': value['wsppWebSiteNo'],
        'wsppPromotionsName': value['wsppPromotionsName'],
        'wsppPromotionsCode': value['wsppPromotionsCode'],
        'wsppPromotionsDateS': value['wsppPromotionsDateS'],
        'wsppPromotionsDateE': value['wsppPromotionsDateE'],
        'wsppApplicableType': value['wsppApplicableType'],
        'wsppPromotionsType': value['wsppPromotionsType'],
        'wsppProductMenuNo': value['wsppProductMenuNo'],
        'wsppDiscountType': value['wsppDiscountType'],
        'wsppDiscountValue': value['wsppDiscountValue'],
        'wsppUseStatus': value['wsppUseStatus'],
        'wsppDisabledDate': value['wsppDisabledDate'] == null ? undefined : (value['wsppDisabledDate'].toISOString()),
    };
}
